// sections/Products.tsx
import { useLanguage } from '@/hooks/useLanguage';
import { ProductCard } from '@/components/ProductCard';

export const Products = () => {
  const { t } = useLanguage();

  const products = [
    {
      title: t.products.class1.title,
      description: t.products.class1.description,
      features: t.products.class1.features,
      notice: t.products.class1.notice,
      imageSrc: '/images/products/class1.png',
      imageAlt: 'Class 1 Process Indicators',
      downloadFile: t.products.class1.downloadIFU
    },
    {
      title: t.products.class4.title,
      description: t.products.class4.description,
      features: t.products.class4.features,
      notice: t.products.class4.notice,
      imageSrc: '/images/products/class4.png',
      imageAlt: 'Class 4 Multivariable Indicators',
      downloadFile: t.products.class4.downloadIFU
    },
    {
      title: t.products.class5.title,
      description: t.products.class5.description,
      features: t.products.class5.features,
      notice: t.products.class5.notice,
      imageSrc: '/images/products/class5.png',
      imageAlt: 'Class 5 Integrator',
      downloadFile: t.products.class5.downloadIFU
    },
    {
      title: t.products.bowieDick.title,
      description: t.products.bowieDick.description,
      features: t.products.bowieDick.features,
      notice: t.products.bowieDick.notice,
      imageSrc: '/images/products/bowiedick.png',
      imageAlt: 'Bowie-Dick Test Sheets/Packs',
      downloadFile: t.products.bowieDick.downloadIFU
    },
  ];

  const handleDownloadIFU = () => {
    console.log('Download IFU clicked');
  };

  const handleRequestQuote = () => {
    const element = document.querySelector('#contact');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="products" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {t.products.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t.products.subtitle}
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-primary to-secondary mx-auto mt-6 rounded-full" />
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map((product, index) => (
            <ProductCard
              key={index}
              title={product.title}
              description={product.description}
              features={product.features}
              imageSrc={product.imageSrc}
              imageAlt={product.imageAlt}
              notice={product.notice}
              downloadFile={product.downloadFile}
              onDownloadIFU={handleDownloadIFU}
              onRequestQuote={handleRequestQuote}
            />
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-600 mb-6">{t.products.cta.text}</p>
          <button
            onClick={handleRequestQuote}
            className="bg-primary hover:bg-primary/90 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg"
          >
            {t.products.cta.buttonText}
          </button>
        </div>
      </div>
    </section>
  );
};
